import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // Data is immediately stale
      cacheTime: 1000 * 60 * 5, // Keep in cache for 5 minutes but mark as stale immediately
      refetchOnWindowFocus: true, // Refetch on window focus to get fresh data
      refetchOnMount: true, // Always refetch on component mount
    },
  },
});

export default queryClient;
